import '../styles/sports-page.scss';
import MatchCard from "../components/MatchCard";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import DiceIcon from "../components/icons/DiceIcon";
import CasinoIcon from "../components/icons/CasinoIcon";
import Football1Icon from "../components/icons/Football1Icon";
import LiveIcon from "../components/icons/LiveIcon";
import { useLanguage } from "../contexts/LanguageProvider";
import ContentSlider from "../components/ContentSlider";
import { useState, useEffect } from 'react';

const SportsPage = () => {
    // Get language context
    const language = useLanguage();

    // Match data array with state
    const [matchData, setMatchData] = useState([
        { id: 1, teamA: 'Chealsea', teamB: 'Liverpool', oddA: 1.25, oddB: 1.25, oddAB: 1.25 },
        { id: 2, teamA: 'West Ham', teamB: 'Arsenal', oddA: 1.25, oddB: 1.25, oddAB: 1.25 },
        { id: 3, teamA: 'Chealsea', teamB: 'Liverpool', oddA: 1.25, oddB: 1.25, oddAB: 1.25 },
        { id: 4, teamA: 'West Ham', teamB: 'Arsenal', oddA: 1.25, oddB: 1.25, oddAB: 1.25 }
    ]);

    // Track the last updated odds
    const [lastUpdated, setLastUpdated] = useState({ matchId: null, oddType: null });

    // Update a random odds value every 5 seconds
    useEffect(() => {
        const updateInterval = setInterval(() => {
            // Select a random match
            const randomMatchIndex = Math.floor(Math.random() * matchData.length);
            const randomMatch = matchData[randomMatchIndex];

            // Select a random odds type (oddA, oddB, or oddAB)
            const oddsTypes = ['oddA', 'oddB', 'oddAB'];
            const randomOddsType = oddsTypes[Math.floor(Math.random() * oddsTypes.length)];

            // Generate a new random odds value (between 1.1 and 3.0)
            const newOddsValue = parseFloat((Math.random() * 1.9 + 1.1).toFixed(2));

            // Update the match data
            const updatedMatchData = [...matchData];
            updatedMatchData[randomMatchIndex] = {
                ...randomMatch,
                [randomOddsType]: newOddsValue
            };

            // Update state
            setMatchData(updatedMatchData);
            setLastUpdated({ matchId: randomMatch.id, oddType: randomOddsType });
        }, 5000);

        // Clean up interval on component unmount
        return () => clearInterval(updateInterval);
    }, [matchData]);

    return (
        <div className='sports-page-root'>
            <div className="container max-w-screen-xl mx-auto px-2 py-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 landing-section">
                    <div className='element'>
                        <div className='text-white'>
                            <h3 className="text-lg font-bold">{language.t('signUpAndGetReward')}</h3>
                            <h2>{language.t('upTo')} <span className='secondary-color'>$ 20,000</span></h2>
                            <button className='px-8 py-3 primary-bg font-semibold rounded mt-5 hover:brightness-90'>{language.t('createAccount')}</button>
                        </div>
                    </div>
                    <div className="element">
                        <div className='flex justify-end'>
                            <img className='landing-image' src='images/landing.png' alt='landing' />
                        </div>
                    </div>
                </div>

                <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={20}
                >
                    {matchData.map(match => (
                        <SwiperSlide key={match.id} style={{ width: '380px' }}>
                            <MatchCard 
                                teamA={match.teamA} 
                                teamB={match.teamB} 
                                oddA={match.oddA} 
                                oddB={match.oddB} 
                                oddAB={match.oddAB}
                                matchId={match.id}
                                lastUpdated={lastUpdated}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 actions-section py-10'>
                    <div className='card casino-background'>
                        <div className='flex gap-2 items-center'>
                            <img src='images/icons/cards.png' alt='casino' />
                            <h3 className='open-sans-bold'>{language.t('casino')}</h3>
                        </div>
                        <p>
                            {language.t('casinoDescription')}
                        </p>
                        <div className='flex justify-around gap-4 pt-3'>
                            <button className='px-8 py-3 w-full secondary-bg button-with-rotate-svg font-semibold rounded flex justify-center items-center gap-2'>
                                <DiceIcon />
                                {language.t('casino')}
                            </button>
                            <button className='px-8 py-3 w-full primary-bg button-with-rotate-svg font-semibold rounded flex justify-center items-center gap-2'>
                                <CasinoIcon />
                                {language.t('liveCasino')}
                            </button>
                        </div>
                    </div>
                    <div className='card sports-background'>
                        <div className='flex gap-2 items-center'>
                            <img src='images/icons/football.png' alt='sport' />
                            <h3 className='open-sans-bold'>{language.t('sport')}</h3>
                        </div>
                        <p>
                            {language.t('sportDescription')}
                        </p>
                        <div className='flex justify-around gap-4 pt-3'>
                            <button className='px-8 py-3 w-full secondary-bg button-with-rotate-svg font-semibold rounded flex justify-center items-center gap-2'>
                                <Football1Icon />
                                {language.t('sport')}
                            </button>
                            <button className='px-8 py-3 w-full primary-bg button-with-rotate-svg font-semibold rounded flex justify-center items-center gap-2'>
                                <LiveIcon />
                                {language.t('live')}
                            </button>
                        </div>
                    </div>
                </div>

                <ContentSlider title={language.t('casino')}>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/1.png" alt='Content 1' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/2.png" alt='Content 1' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/3.png" alt='Content 1' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/4.png" alt='Content 1' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/5.png" alt='Content 1' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/6.png" alt='Content 1'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/7.png" alt='Content 1'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/8.png" alt='Content 1'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/9.png" alt='Content 1'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/10.png" alt='Content 1'/>
                    </SwiperSlide>
                </ContentSlider>

                <ContentSlider title={language.t('topRatedGames')}>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/10.png" alt='Content 10' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/9.png" alt='Content 9' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/8.png" alt='Content 8' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/7.png" alt='Content 7' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/6.png" alt='Content 6' />
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/5.png" alt='Content 5'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/4.png" alt='Content 4'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/3.png" alt='Content 3'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/2.png" alt='Content 2'/>
                    </SwiperSlide>
                    <SwiperSlide className='content-v-image'>
                        <img src="images/content-v/1.png" alt='Content 1'/>
                    </SwiperSlide>
                </ContentSlider>

                <ContentSlider title={language.t('liveCasino')}>
                    <SwiperSlide className='content-h-image'>
                        <img src="images/content-h/1.png" alt='Content 10' />
                    </SwiperSlide>
                    <SwiperSlide className='content-h-image'>
                        <img src="images/content-h/2.png" alt='Content 9' />
                    </SwiperSlide>
                    <SwiperSlide className='content-h-image'>
                        <img src="images/content-h/3.png" alt='Content 8' />
                    </SwiperSlide>
                    <SwiperSlide className='content-h-image'>
                        <img src="images/content-h/4.png" alt='Content 7' />
                    </SwiperSlide>
                </ContentSlider>
            </div>
        </div>
    )
}

export default SportsPage;
